import { QUERY_KEYS } from "library/shared";
import { IBenefitImplementationSecurity } from "library/types";
import { UseQueryResult, useQuery, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string | null;
  clientInternalNumberGOS: number | string;
  enabled?: boolean;
};

const getBenefitImplementationSecurities = async ({
  countryCode,
  clientInternalNumberGOS,
}: Params) => {
  if (countryCode === null || clientInternalNumberGOS === null) return;

  const response = await api.get(
    `/benefitimplementation/security/${countryCode}/${clientInternalNumberGOS}`
  );

  return response.data;
};

export function useGetBenefitImplementationSecurities({
  countryCode,
  clientInternalNumberGOS,
  enabled = true,
}: Params): UseQueryResult<IBenefitImplementationSecurity[]> {
  return useQuery<IBenefitImplementationSecurity[], Error>(
    [
      QUERY_KEYS.benefitImplementationSecurities,
      countryCode?.toString(),
      clientInternalNumberGOS?.toString(),
    ],
    () =>
      getBenefitImplementationSecurities({
        countryCode,
        clientInternalNumberGOS,
      }),
    {
      enabled: enabled,
      //staleTime: 0,
      refetchOnMount: true,
      //   onError: (error: any) => {
      //     errorHandler({
      //       label: "Error",
      //       type: notificationTypes.error,
      //       value: "Error while loading offer item data",
      //       errors: error?.message,
      //       fieldName: "",
      //     });
      //   },
    }
  );
}

export const useInvalidateBenefitImplementationSerurities = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.benefitImplementationSecurities,
    });
};
export const useRefetchBenefitImplementationSerurities = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.refetchQueries({
      queryKey: QUERY_KEYS.benefitImplementationSecurities,
    });
};
